import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { IconButton, Popover, Typography, Button } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";
import { useUserProfile } from "../hooks/useQueries";

function ProfileButton() {
  const { isAuthenticated, logout, user } = useAuth0();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "profile-popover" : undefined;
  const { data: profileData } = useUserProfile();
  const userData = profileData || {
    affiliation: "",
    email: user?.email || "",
    name: user?.name || "",
    subId: user?.sub || "",
    givenName: user?.givenName || "",
  };

  const handleProfileClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <>
      {isAuthenticated && (
        <>
          <IconButton
            onClick={handleProfileClick}
            aria-describedby={id}
            color="inherit"
          >
            <AccountCircleIcon />
          </IconButton>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <div style={{ padding: 20 }}>
              <Typography variant="h6" gutterBottom>
                {userData.name}
              </Typography>
              <Typography variant="body1" gutterBottom>
                Affiliation: {userData.affiliation ?? "not set"}
              </Typography>
              <Button
                variant="outlined"
                color="inherit"
                fullWidth
                component={Link}
                to="/profile"
                sx={{ marginBottom: 1 }}
              >
                View Profile
              </Button>
              <Button
                variant="contained"
                color="error"
                fullWidth
                onClick={handleLogout}
                sx={{ marginBottom: 1 }}
              >
                Logout
              </Button>
            </div>
          </Popover>
        </>
      )}
    </>
  );
}

export default ProfileButton;
